import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-295c6346"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "g-container my-2.5 hidden sm:block" }
const _hoisted_2 = { class: "bg-[#FAFAFA]" }
const _hoisted_3 = { class: "w-full mx-auto text-xs text-gary-text-color tracking-[.1em] sm:text-sm flex flex-col gap-6 sm:px-[20%] p-1.5 sm:py-[50px] pt-[50px]" }
const _hoisted_4 = { class: "text-gary-text-color font-bold text-[18px] sm:text-[24px] text-center leading-[1.25] px-[30px]" }
const _hoisted_5 = { class: "flex items-center justify-center w-[80%] m-auto mt-[-21px]" }
const _hoisted_6 = { class: "mt-[-2px]" }
const _hoisted_7 = { class: "w-full flex sm:flex-row flex-col gap-[30px] px-[30px] justify-center" }
const _hoisted_8 = { class: "w-auto" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gary-text-color font-medium text-sm text-left" }, " 活動說明 ", -1))
const _hoisted_10 = { class: "text-left text-xs leading-[17px] list-disc list-none pl-0 content-list" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "w-auto sm:ml-[20px]" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gary-text-color font-medium text-sm text-left" }, " 注意事項 ", -1))
const _hoisted_14 = { class: "text-left text-xs leading-[17px] list-disc list-none pl-0 warningDesc-list" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "g-container flex flex-col sm:mt-10 sm:p-0" }
const _hoisted_17 = { class: "g-container flex flex-col pt-0 sm:p-0" }
const _hoisted_18 = { class: "flex gap-[8px] sm:mx-[240px] mx-[16px]" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mobile-none" }, "主打", -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode("商品 ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 已選 ")
const _hoisted_22 = ["onMouseenter"]
const _hoisted_23 = { class: "cart-count-num" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cart-count-unit" }, "件", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex-1 mr-auto" }, "組合優惠提醒", -1))
const _hoisted_26 = { class: "cart-modal-body" }
const _hoisted_27 = { class: "flex justify-center gap-[8px] px-[15px] cart-modal-btns" }

import { ref, onMounted, provide, watch, onBeforeUnmount, nextTick, reactive } from 'vue'
import Icon from '@/components/common/Icon.vue'
import Title from '@/components/common/Title.vue'
import UnderLine from '@/components/common/UnderLine.vue'
import ProductClassItemList from '@/components/ProductClassItemList.vue'
import ProductItemList from '@/components/ProductItemList.vue'
import Banner from '@/components/common/Banner.vue'
import Breadcrumb from '@/components/common/Breadcrumb.vue'
import ColorfulTabs from '@/components/common/ColorfulTabs.vue'
import CartToolbar from '@/components/CartToolbar.vue'
import ModalBase from '@/components/common/ModalBase.vue'
// util
import * as requestUrl from '@/utils/requestUrl'
import request from '@/utils/request'
import { useRouter, useRoute } from 'vue-router'
import productStore from '@/composition/productStore'
import { useToast, POSITION } from 'vue-toastification'
import isMobile from 'ismobilejs'
import store from '@/composition/store'
import map from 'lodash/map'
import cartStore from '@/composition/cartStore'
import { COLOR_TYPE, PromotionProductType } from '@/types/PromotionType'
import { colorItems } from '@/constants/PromotionData'
import { capitalize } from '@/utils/utils'
import RedGreenCartModal from '@/components/modal/RedGreenCartModal.vue'
import type RedGreenCartModalType from '@/components/modal/RedGreenCartModal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'RedGreenView',
  setup(__props) {

provide('productStore', productStore)
provide('store', store)
const router = useRouter()
const route = useRoute()
const toast = useToast()
let mediaQuery: MediaQueryList // 偵測螢幕大小變化
const promotionData = ref({} as any)
const RefProductItemList = ref()
const cmdyClassItem = ref<{ Name: string }>({ Name: '' })
const cmdyThemeList = ref([] as any)
const selectThemeList = ref([] as any)
const rowCount = ref(5) // 商品每行個數
const firstLoading = ref(true)
const focusing = ref(false)
const filterRef = ref<HTMLElement | null>(null)
const allColors = ref<COLOR_TYPE[]>([COLOR_TYPE.red, COLOR_TYPE.green, COLOR_TYPE.blue])
const cartToolbarDetail = ref<HTMLElement | null>(null)
// 目前已開啟販促區的購物車
const redGreenCartIsOpen = ref(false)
const currentCartColor = ref<COLOR_TYPE | null>(null)
// 目前已選擇/加入的販促商品
const currentPromotions = reactive<PromotionProductType>({
  activeColor: COLOR_TYPE.red,
  colors: {
    red: [],
    green: [],
    blue: []
  }
})
const promotionsQty = ref<Record<COLOR_TYPE, number>>({
  red: 0,
  green: 0,
  blue: 0
})
// modal
const confirmModal = ref(null)
const redgreenCartModal = ref<InstanceType<typeof RedGreenCartModalType> | null>(null)
const modalShow = ref(false)
const modalContext = ref('')

// 檢查是否有指定的販促商品
const checkPromotionData = (_color: COLOR_TYPE): boolean => {
  return promotionData.value[`CommodityList${capitalize(_color)}`]
}

// 取得商品
const getPromotionCmdyList = async () => {
  if (route.query.cmdyTagId !== undefined) {
    await getPromotionCmdyListById()
  }

  await productStore
    .fetchPromotionCmdyList(route.query.promotionId?.toString() || '')
    .then((res) => {
      promotionData.value = res.resData
      promotionData.value.Content = promotionData.value.Content.map((item: string) => {
        return item.replace(/\n/g, '<br/>')
      })
      promotionData.value.WarningDesc = promotionData.value.WarningDesc.map((item: string) => {
        return item.replace(/\n/g, '<br/>')
      })
      // cmdyClassItem.value = res.cmdyClass
      // debugger
      // productStore.setShowLoading(false)
    })
    .catch(() => {
      toast.warning('查不到此商品分類，已幫你轉導到首頁', {
        position: POSITION.TOP_CENTER
      })
      router.push({ name: 'home' })
    })
}

// 取得篩選商品
const getPromotionCmdyListById = async (tagClick = false) => {
  productStore.setShowRectangleItem(false)
  store.setShowLoading(true)
  if (tagClick) {
    route.query.cmdyTagId =
      productStore.state.selectedCmdyTag.CmdyTagId
  }

  router.replace({
    query: {
      promotionId: route.query.promotionId?.toString() || '',
      cmdyTagId: route.query.cmdyTagId?.toString() || '',
      dateNow: Date.now()
    }
  })
  const data = {
    Data: {
      PageNum: 0,
      PageSize: 0,
      PromotionActId: route.query.promotionId?.toString() || '',
      CmdyTagId: route.query.cmdyTagId?.toString() || '',
      OrderType: productStore.state.selectedOrderType,
      Zone: capitalize(currentPromotions.activeColor)
    }
  }
  await request
    .post(
      window._env_.VUE_APP_STOREBOOK_SERVICE_API +
      requestUrl.getCmdyListByPromotionId,
      data, {
        headers: {
          'api-version': '2.0'
        }
      }
    )
    .then((res) => {
      const resData = res.data.Data
      if (resData.CmdyList.length !== 0) {
        const cmdyList = map(resData.CmdyList, (item: any) => {
          if (item.Checked === undefined) {
            item.Checked = false
          }
          if (item.IsEndProduct === undefined) {
            item.IsEndProduct = 1
          }
          return item
        })
        productStore.setCmdyList(cmdyList)

        if (route.query.cmdyTagId && !tagClick) {
          productStore.state.cmdyTagList.forEach((item: any) => {
            if (item.CmdyTagId === route.query.cmdyTagId) {
              productStore.setSelectedCmdyTag(item)
            }
          })
        }
      } else {
        productStore.setCmdyList([])
      }
      store.setShowLoading(false)
    })
    .catch((error) => {
      store.setShowLoading(false)
      console.error(error)
    })
}

const closeRecItem = () => {
  if (
    productStore.state.showRectangleItem === true &&
    store.state.showLoading === 0 &&
    store.state.showLoginModal === false
  ) {
    setPromotionProduct('', currentPromotions.activeColor) // 取消目前選取的商品
    productStore.setShowRectangleItem(false)
  }
}

const clickProductItemList = async () => {
  route.query.cmdyId = ''
  route.params.cmdyThemeId = ''
  // router.push({ name: 'home' })
  await getPromotionCmdyList()
}

const clickProductItem = (cmdyId: string) => {
  // route.query.cmdyId = productStore.state.selectedCmdy.CmdyId
  router.replace({
    query: {
      // shopHallCode: route.query.shopHallCode,
      promotionId: route.query.promotionId?.toString() || '',
      cmdyClassId: route.query.promotionId?.toString() || '',
      subCmdyClassId: productStore.state.selectedCmdyClass.CmdyClassId,
      cmdyTagId: productStore.state.selectedCmdyTag.CmdyTagId || '',
      cmdyId: cmdyId || productStore.state.selectedCmdy.CmdyId
      // dateNow: Date.now()
    }
  })
}

// 檢查是否大於 mediaQuery 的設定
const updateMatch = (e: MediaQueryListEvent) => {
  // 調整每行卡片的個數
  rowCount.value = e.matches ? 5 : 2
}

// 更換目前販促區域
const setPromotionType = (_color: COLOR_TYPE) => {
  setPromotionProduct('', currentPromotions.activeColor) // 移除未加入購物車的資料
  currentPromotions.activeColor = _color

  // 取得不同區的資料
  productStore.setCmdyTagList(promotionData.value[`CmdyTagList${capitalize(_color)}`])
  productStore.setCmdyList(promotionData.value[`CommodityList${capitalize(_color)}`])

  // 將篩選類別復原
  router.replace({
    query: {
      ...route.query,
      cmdyTagId: ''
    }
  })
  productStore.setSelectedCmdyTag({})

  nextTick(() => {
    if (!firstLoading.value) {
      filterRef.value?.scrollIntoView({ behavior: 'smooth' })
    }
  })
}

// 更新已選販促商品
const setPromotionProduct = (_id: string, _color: COLOR_TYPE) => {
  focusing.value = false
  if (checkPromotionData(_color)) return

  const list = currentPromotions.colors[_color]
  const index = list.findIndex(item => item.id === _id)

  // 新增選擇的商品
  if (index === -1) {
    // 如果為新加入的商品，同時移除其他非 added 的商品
    currentPromotions.colors[_color] = list.filter(item => item.added)

    if (_id) {
      focusing.value = true
      currentPromotions.colors[_color].push({
        id: _id,
        added: false,
        qty: 0
      })
    }
  }
}

// 取得各販促區的購物數量
const getPromotionsQty = async () => {
  // 單純前端處理
  // return currentPromotions.colors[color].reduce((sum, item) => sum + item.qty, 0)

  // 串接後端 Api
  for (const color of Object.keys(currentPromotions.colors) as COLOR_TYPE[]) {
    const cmdyIdList = currentPromotions.colors[color].map(m => {
      return {
        CmdyId: m.id,
        Count: m.qty
      }
    })

    const res = await request
      .post(
        window._env_.VUE_APP_STOREBOOK_SERVICE_API +
        requestUrl.getRedGreenBundleDiscountCount,
        {
          Data: {
            ShopCode: 'G-Gift',
            PromotionActivityId: route.query.promotionId?.toString() || '',
            CmdyIdList: cmdyIdList
          }
        }
      )

    promotionsQty.value[color] = res.data.Data[`${capitalize(color)}ZoneCount`]
  }
}

// 是否沒有選購的商品
const noSelectedPromotion = () => {
  return Object.values(currentPromotions.colors)
    .flat()
    .filter(item => item.added)
    .reduce((sum, item) => sum + item.qty, 0) === 0
}

// 檢查購物車的內容，提示使用者販促資訊
const checkCart = async () => {
  if (!confirmModal.value) return

  // 依照有效顏色建立數量對照
  const currentQty = currentPromotions.colors
  const requestData = {
    ShopCode: 'G-Gift',
    PromotionActivityId: route.query.promotionId?.toString() || '',
    RedZoneCount: currentQty.red.reduce((sum, item) => sum + item.qty, 0),
    GreenZoneCount: currentQty.green.reduce((sum, item) => sum + item.qty, 0),
    BlueZoneCount: currentQty.blue.reduce((sum, item) => sum + item.qty, 0)
  }

  let message = ''

  try {
    const res = await request
      .post(
        window._env_.VUE_APP_STOREBOOK_SERVICE_API +
        requestUrl.getRedGreenBundleDiscountResult,
        {
          Data: requestData
        }
      )

    message = res.data.Data.ComboDiscountReminder
  } catch (error) {
    message = '系統讀取錯誤，請稍後再試'
  }

  modalContext.value = message
  modalShow.value = true
}

// 繼續選購
const continueShopping = () => {
  modalShow.value = false
}

// 前往結帳
const gotoCart = () => {
  router.push({
    name: 'shoppingCart',
    params: {
      dateNow: Date.now()
    }
  })
}

// 初始化已加入的販促商品
const initCurrentPromotions = () => {
  // 查找購物車的商品
  for (const item of cartStore.state.orderShoppingCartCmdyList) {
    // 尋找各顏色區
    for (const color in COLOR_TYPE) {
      const eachColor = color as COLOR_TYPE

      // 判斷是否為目前已在 currentPromotions 的項目
      const existing = currentPromotions.colors[eachColor].find(p => p.id === item.CmdyId)

      if (existing) {
        // 如果是目前已有的項目，更新加入
        existing.added = true
        existing.qty = item.CmdyQty
      } else {
        // 檢查是否包含指定區域的商品
        if (!checkPromotionData(eachColor)) continue

        // 如果並不存在，判斷該商品是否為販促商品後加入
        if (
          promotionData.value[`CommodityList${capitalize(eachColor)}`]
            .some((pd: any) => pd.CmdyId === item.CmdyId)
        ) {
          currentPromotions.colors[eachColor].push({
            id: item.CmdyId,
            added: true,
            qty: item.CmdyQty
          })
        }
      }
    }
  }
}

// 開啟各販促區購物車
const openRedGreenCart = (_color: COLOR_TYPE) => {
  if (!redgreenCartModal.value) return

  currentCartColor.value = _color
  redgreenCartModal.value.openCart(_color)
}

// 檢查販促區購物車是否開啟
const redGreenCartControl = (isOpen: boolean) => {
  redGreenCartIsOpen.value = isOpen
  if (!isOpen) currentCartColor.value = null
}

watch(
  () => productStore.state.selectedOrderType,
  async () => {
    await getPromotionCmdyListById()
  }
)

watch(
  () => route.query.promotionId,
  async () => {
    if (route.name === 'redgreenList') {
      // productStore.setSelectedCmdyClass({})
      await getPromotionCmdyList()
    }
  }
)

// 監聽購物車的資料，更新到 currentPromotions
watch(
  () => cartStore.state.orderShoppingCartCmdyList,
  (newVal) => {
    // 一開始商品資料未處理完畢，不執行
    if (!promotionData.value || Object.keys(promotionData.value).length === 0) return

    initCurrentPromotions()

    // 目前購物車的商品
    const newValIds = new Set(newVal.map((item: { CmdyId: string }) => item.CmdyId))

    // 尋找各顏色區
    for (const color in COLOR_TYPE) {
      const activeColor = color as COLOR_TYPE

      // 移除已不在購物車的商品
      for (let i = 0; i < currentPromotions.colors[activeColor].length; i++) {
        if (!newValIds.has(currentPromotions.colors[activeColor][i].id) && !focusing.value) {
          currentPromotions.colors[activeColor].splice(i, 1)
        }
      }
    }
  }
)

watch(
  () => currentPromotions,
  async () => {
    await getPromotionsQty()
  },
  { deep: true, immediate: true }
)

onMounted(async () => {
  productStore.resetAllStatus()

  // 取得商品資料
  await getPromotionCmdyList()

  // 根據優先順序決定預設的 COLOR_TYPE
  const getDefaultPromotionType = (): COLOR_TYPE => {
    for (const color of allColors.value) {
      if (checkPromotionData(color)) {
        return color
      }
    }
    return COLOR_TYPE.red
  }

  // 販促商品資料初始化
  const defaultColor = getDefaultPromotionType()
  setPromotionType(defaultColor)
  initCurrentPromotions()

  // 監聽螢幕大小，決定每行要顯示的個數
  mediaQuery = window.matchMedia('(min-width: 641px)')
  rowCount.value = mediaQuery.matches ? 5 : 2
  mediaQuery.addEventListener('change', updateMatch)

  await nextTick()
  firstLoading.value = false
})

onBeforeUnmount(() => {
  mediaQuery.removeEventListener('change', updateMatch)
})

return (_ctx: any,_cache: any) => {
  const _directive_clickOutSide = _resolveDirective("clickOutSide")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Breadcrumb, {
          breadcrumbList: [{ path: '/', title: cmdyClassItem.value.Name || '' }]
        }, null, 8, ["breadcrumbList"])
      ]),
      _createVNode(Banner, {
        image: promotionData.value.BannerImage !== undefined ? promotionData.value.BannerImage : { PcWeb: '', MobileWeb: '' }
      }, null, 8, ["image"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(promotionData.value.Name), 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(Icon, { "icon-name": "clock" }),
            _createElementVNode("p", _hoisted_6, _toDisplayString(promotionData.value.EffectiveDateStart) + " - " + _toDisplayString(promotionData.value.EffectiveDateEnd), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("ul", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(promotionData.value.Content, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    innerHTML: item
                  }, null, 8, _hoisted_11))
                }), 128))
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("ul", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(promotionData.value.WarningDesc, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    innerHTML: item
                  }, null, 8, _hoisted_15))
                }), 128))
              ])
            ], 512), [
              [_vShow, promotionData.value.WarningDesc?.length > 0]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(Title, {
          class: "g-title-type2 mt-[40px] mb-[40px] sm:my-[60px]",
          title: "期間限定"
        }),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", {
            class: _normalizeClass(["mx-[16px]", { 'toolbar-sticky': _unref(isMobile)().phone }])
          }, [
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(colorItems), (colorItem) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: colorItem.color
                }, [
                  (checkPromotionData(colorItem.color))
                    ? (_openBlock(), _createBlock(ColorfulTabs, {
                        key: 0,
                        variant: colorItem.variant,
                        outline: true,
                        class: _normalizeClass(["flex-auto", { active: currentPromotions.activeColor === colorItem.color }]),
                        onClick: ($event: any) => (setPromotionType(colorItem.color))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(colorItem.name), 1),
                          _hoisted_19,
                          _hoisted_20
                        ]),
                        _: 2
                      }, 1032, ["variant", "class", "onClick"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]),
            _createVNode(UnderLine, { style: {"margin-top":"0"} })
          ], 2),
          _createElementVNode("div", {
            ref_key: "filterRef",
            ref: filterRef,
            style: {"scroll-margin-top":"105px"}
          }, [
            _createVNode(ProductClassItemList, {
              onGetCmdyClassList: _cache[0] || (_cache[0] = ($event: any) => (getPromotionCmdyListById(true)))
            })
          ], 512),
          _withDirectives((_openBlock(), _createElementBlock("div", null, [
            _createVNode(ProductItemList, {
              ref_key: "RefProductItemList",
              ref: RefProductItemList,
              class: "mt-[10px] sm:mt-[30px] md:mt-[36px]",
              getCmdyClassList: clickProductItemList,
              "onUpdate:getCmdyClassList": _cache[1] || (_cache[1] = ($event: any) => ((clickProductItemList) = $event)),
              cmdyThemeList: cmdyThemeList.value,
              "onUpdate:cmdyThemeList": _cache[2] || (_cache[2] = ($event: any) => ((cmdyThemeList).value = $event)),
              selectThemeList: selectThemeList.value,
              "onUpdate:selectThemeList": _cache[3] || (_cache[3] = ($event: any) => ((selectThemeList).value = $event)),
              onClickProductItem: clickProductItem,
              row: rowCount.value,
              isMobile: _unref(isMobile)().phone,
              hideSpec: true,
              promotionHighlight: currentPromotions.activeColor,
              currentPromotions: currentPromotions,
              onSelectedCurrentPromotion: setPromotionProduct
            }, null, 8, ["cmdyThemeList", "selectThemeList", "row", "isMobile", "promotionHighlight", "currentPromotions"])
          ])), [
            [_directive_clickOutSide, closeRecItem]
          ])
        ])
      ])
    ]),
    _createVNode(CartToolbar, { onCheckCart: checkCart }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          ref_key: "cartToolbarDetail",
          ref: cartToolbarDetail,
          class: "cart-selected-detail"
        }, [
          _hoisted_21,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(colorItems), (colorItem) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: colorItem.color
            }, [
              (checkPromotionData(colorItem.color))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["cart-count", [
            `cart-count-${colorItem.color}`,
            { active: redGreenCartIsOpen.value && currentCartColor.value === colorItem.color }
          ]]),
                    onMouseenter: ($event: any) => (openRedGreenCart(colorItem.color))
                  }, [
                    _createTextVNode(_toDisplayString(colorItem.name) + " ", 1),
                    _createElementVNode("span", _hoisted_23, _toDisplayString(promotionsQty.value[colorItem.color]), 1),
                    _hoisted_24
                  ], 42, _hoisted_22))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ], 512)
      ]),
      _: 1
    }),
    _createVNode(RedGreenCartModal, {
      ref_key: "redgreenCartModal",
      ref: redgreenCartModal,
      promotionData: currentPromotions,
      clickableRef: cartToolbarDetail.value,
      onOpenControl: redGreenCartControl
    }, null, 8, ["promotionData", "clickableRef"]),
    _createVNode(ModalBase, {
      ref_key: "confirmModal",
      ref: confirmModal,
      show: modalShow.value,
      class: "cart-modal modal-300-width"
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", { class: "cart-modal-title" }, [
          _hoisted_25,
          _createElementVNode("button", {
            type: "button",
            style: {"transform":"translateY(-11.5px)"},
            onClick: continueShopping
          }, "×")
        ])
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_26, _toDisplayString(modalContext.value), 1)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("button", {
            type: "button",
            class: "modal-btn-confirm",
            onClick: gotoCart
          }, _toDisplayString(noSelectedPromotion() ? '先不用' : '前往結帳'), 1),
          _createElementVNode("button", {
            type: "button",
            class: "modal-btn-cancel",
            onClick: continueShopping
          }, _toDisplayString(noSelectedPromotion() ? '再逛逛' : '繼續選購'), 1)
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})